var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:"onlineImg",staticClass:"cursor-pointer block",attrs:{"src":require("@/assets/images/logo/logo.png"),"alt":"pannonhome-logo","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }